'use client';

import type { PageConfigType } from '@/types';
import PurchaseButton from '@/components/PurchaseButton';
import { Box, Typography } from '@mui/material';
const FinalCTA = ({
  config
}: {
  config: PageConfigType;
}) => {
  return <Box textAlign="center" mt={12} py={{
    xs: 8,
    md: 12
  }} sx={{
    backgroundColor: '#330066',
    borderRadius: 4,
    boxShadow: 3,
    px: 2
  }} data-sentry-element="Box" data-sentry-component="FinalCTA" data-sentry-source-file="FinalCTA.tsx">
      <Typography variant="h3" fontWeight="bold" mb={4} sx={{
      color: 'primary.contrastText',
      textShadow: '1px 1px 2px rgba(0,0,0,0.2)'
    }} component="h2" data-sentry-element="Typography" data-sentry-source-file="FinalCTA.tsx">
        {`Get Started Today — Ace Your ${config.examName}!`}
      </Typography>

      <Typography variant="h6" fontWeight="normal" color="primary.contrastText" mb={6} component="h2" data-sentry-element="Typography" data-sentry-source-file="FinalCTA.tsx">
        Practice smarter. Pass faster. 200+ expertly written questions with detailed explanations.
      </Typography>

      <Box data-sentry-element="Box" data-sentry-source-file="FinalCTA.tsx">
        <PurchaseButton price={0} productCode={config.code} data-sentry-element="PurchaseButton" data-sentry-source-file="FinalCTA.tsx" />
      </Box>
    </Box>;
};
export default FinalCTA;